// extracted by mini-css-extract-plugin
export default {"xStoreAdditionalSettingsCheckboxes":"SubscriptionSettingsPage_xStoreAdditionalSettingsCheckboxes__knbzi","text":"SubscriptionSettingsPage_text__eRSfW"};